import http from '@/utils/http'

// 在线交存-提交
export function fetchDepositOnlineCommit(data) {
  return http.post('/api/wx/public/deposit/online/commit',data)
}

// 交存明细查询列表
export function fetchDepositList(query) {
  return http.get('/api/wx/public/deposit/list', {
    params: query
  })
}
// 去支付  提交交存申请号
export function DepositPay(data) {
  return http.post('/api/wx/public/defray/online',data)
}
// 下载交存凭证
export function download(data){
  return http.post('/api/maintenance-fund/weixin/allTicketRequests',data)
}

//自助打印二维码
export function selectImageWeChat(data) {
  return http.post('/api/bvrfis/selectImageWeChat.bv', data)
}
